import { TbTrekking } from "react-icons/tb";
import { MdFlightTakeoff, MdEventRepeat, MdTempleBuddhist } from "react-icons/md";
import { FaCar, FaCampground, FaBookOpenReader } from "react-icons/fa6";
import { FaWineGlassAlt, FaYoutube } from "react-icons/fa";
import { SiAnimalplanet } from "react-icons/si";
import { GrGallery } from "react-icons/gr";

export const cmsSegments = [
  { title: "Trek", icon: <TbTrekking />, link: "/cms/trek", disabled: false },
  { title: "Tour", icon: <MdFlightTakeoff />, link: "/cms/tour", disabled: true },
  { title: "Travel", icon: <FaCar />, link: "/cms/travel", disabled: false },
  { title: "Upcoming Events", icon: <MdEventRepeat />, link: "/cms/upcoming-event", disabled: false, directRoute: true },
  { title: "Archeological Sites", icon: <MdTempleBuddhist />, link: "/cms/archeological-sites", disabled: true },
  { title: "Wildlife Sanctuary", icon: <SiAnimalplanet />, link: "/cms/wildlife-sanctuary", disabled: true },
  { title: "Winery", icon: <FaWineGlassAlt />, link: "/cms/winery", disabled: true },
  { title: "Camping", icon: <FaCampground />, link: "/cms/camping", disabled: true },
  { title: "Youtube Videos", icon: <FaYoutube />, link: "/cms/youtube-video", disabled: false, directRoute: true },
  { title: "Image Gallery", icon: <GrGallery />, link: "/cms/image-gallery", disabled: false, directRoute: true },
  { title: "Reader's Corner", icon: <FaBookOpenReader />, link: "/cms/readers-corner", disabled: true },
];
